<template>
    <q-card class="full-height bg-white">
        <q-card-title class="text-center bg-primary text-white">
            {{ $t('statistics') }}
        </q-card-title>

        <q-card-separator />

        <q-card-main class="relative-position full-height q-my-md">
            <div class="row">
                <div class="col-12 q-subheading text-weight-regular" v-if="clientModules.has_courses">
                    {{ statistics.qty_group_trainings_published }} {{ $t('published_trainings') }}
                </div>
                <div :class="$q.platform.is.mobile ? 'col-10 offset-1' : 'col-12'" v-if="clientModules.has_courses">
                    <q-slider
                        v-model="qty_group_trainings_certified"
                        :min="0"
                        :step="1"
                        :max="qty_group_trainings_published"
                        label
                        label-always
                        readonly
                        :label-value="`${$t('progress')}: ${user_group_training_progress}% / ${$t('average')}: ${avg_group_trainings_certified}%`"
                        />
                </div>

                <div class="col-12 q-subheading text-weight-regular" v-if="clientModules.has_trails">
                    {{ statistics.qty_trails_published }} {{ $t('published_trails') }}
                </div>
                <div :class="$q.platform.is.mobile ? 'col-10 offset-1' : 'col-12'" v-if="clientModules.has_trails">
                    <q-slider
                        v-model="qty_trails_certified"
                        :min="0"
                        :step="1"
                        :max="qty_trails_published"
                        label
                        label-always
                        readonly
                        :label-value="`${$t('progress')}: ${user_trails_progress}%`"
                        />
                </div>

                <div class="col-12 q-subheading text-weight-regular" v-if="clientModules.has_presential">
                    {{ statistics.qty_presential_published }} {{ $t('published_presentials') }}
                </div>
                <div :class="$q.platform.is.mobile ? 'col-10 offset-1' : 'col-12'" v-if="clientModules.has_presential">
                    <q-slider
                        v-model="qty_presential_certified"
                        :min="0"
                        :step="1"
                        :max="qty_presential_published"
                        label
                        label-always
                        readonly
                        :label-value="`${$t('progress')}: ${user_presential_progress}%`"
                        />
                </div>

                <div class="col-12 q-subheading text-weight-regular" v-if="clientModules.has_live_classes">
                    {{ statistics.qty_live_classes_published }} {{ $t('published_live_classes') }}
                </div>
                <div :class="$q.platform.is.mobile ? 'col-10 offset-1' : 'col-12'" v-if="clientModules.has_live_classes">
                    <q-slider
                        v-model="qty_live_classes_certified"
                        :min="0"
                        :step="1"
                        :max="qty_live_classes_published"
                        label
                        label-always
                        readonly
                        :label-value="`${$t('progress')}: ${user_live_classes_progress}%`"
                        />
                </div>

                <div class="col-12 q-subheading text-weight-regular" v-if="clientModules.has_webcasts">
                    {{ statistics.qty_webcasts_published }} {{ $t('published_webcasts') }}
                </div>
                <div :class="$q.platform.is.mobile ? 'col-10 offset-1' : 'col-12'" v-if="clientModules.has_webcasts">
                    <q-slider
                        v-model="qty_webcasts_certified"
                        :min="0"
                        :step="1"
                        :max="qty_webcasts_published"
                        label
                        label-always
                        readonly
                        :label-value="`${$t('progress')}: ${user_webcasts_progress}%`"
                        />
                </div>

                <div class="col-12 q-subheading text-weight-regular" v-if="clientModules.has_podcasts">
                    {{ statistics.qty_podcasts_published }} {{ $t('published_podcasts') }}
                </div>
                <div :class="$q.platform.is.mobile ? 'col-10 offset-1' : 'col-12'" v-if="clientModules.has_podcasts">
                    <q-slider
                        v-model="qty_podcasts_certified"
                        :min="0"
                        :step="1"
                        :max="qty_podcasts_published"
                        label
                        label-always
                        readonly
                        :label-value="`${$t('progress')}: ${user_podcasts_progress}%`"
                        />
                </div>
            </div>
        </q-card-main>
    </q-card>
</template>

<script>
export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'feed'] },

    props: ['statistics', 'clientModules'],

    data() {
        return {
            avg_group_trainings_certified: 0,
            qty_group_trainings_certified: 0,
            qty_group_trainings_published: 100,
            user_group_training_progress: 0,
            qty_presential_certified: 0,
            qty_presential_published: 100,
            user_presential_progress: 0,
            qty_trails_certified: 0,
            qty_trails_published: 100,
            user_trails_progress: 0,
            qty_live_classes_certified: 0,
            qty_live_classes_published: 100,
            user_live_classes_progress: 0,
            qty_webcasts_certified: 0,
            qty_webcasts_published: 100,
            user_webcasts_progress: 0,
            qty_podcasts_certified: 0,
            qty_podcasts_published: 100,
            user_podcasts_progress: 0
        }
    },

    watch: {
        statistics: function() {
            if (this.statistics) {
                this.avg_group_trainings_certified = this.statistics.avg_group_trainings_certified.toFixed(2) * 1
                this.qty_group_trainings_certified = this.statistics.qty_group_trainings_certified
                this.qty_group_trainings_published = this.statistics.qty_group_trainings_published || 100
                this.user_trails_progress = this.statistics.user_trails_progress
                this.qty_trails_published = this.statistics.qty_trails_published || 100
                this.user_group_training_progress = this.statistics.user_group_training_progress.toFixed(2) * 1
                this.user_trails_progress = this.statistics.user_trails_progress.toFixed(2) * 1
                this.qty_trails_certified = this.statistics.qty_trails_certified
                this.qty_presential_certified = this.statistics.qty_presential_certified
                this.qty_presential_published = this.statistics.qty_presential_published || 100
                this.user_presential_progress = this.statistics.user_presential_progress.toFixed(2) * 1
                this.qty_live_classes_certified = this.statistics.qty_live_classes_certified
                this.qty_live_classes_published = this.statistics.qty_live_classes_published || 100
                this.user_live_classes_progress = this.statistics.user_live_classes_progress.toFixed(2) * 1
                this.qty_webcasts_certified = this.statistics.qty_webcasts_certified
                this.qty_webcasts_published = this.statistics.qty_webcasts_published || 100
                this.user_webcasts_progress = this.statistics.user_webcasts_progress.toFixed(2) * 1
                this.qty_podcasts_certified = this.statistics.qty_podcasts_certified
                this.qty_podcasts_published = this.statistics.qty_podcasts_published || 100
                this.user_podcasts_progress = this.statistics.user_podcasts_progress.toFixed(2) * 1
            }
        }
    }
}
</script>

<style>

</style>
